import { ChangeDetectorRef, Directive, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, SortDirection } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { L10nTranslationService } from 'angular-l10n';
import { HttpClient } from "@angular/common/http";
import { Image } from "@ks89/angular-modal-gallery";
import { MediaObserver } from "@ngbracket/ngx-layout";
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { APIConfigService } from "../../../api.config.service";
import { AuthService } from "../../../shared/auth.service";
import { BreadcrumbService } from "../../../shared/breadcrumb/breadcrumb.service";
import { LoggerService } from "../../../shared/logger.service";
import { Kernantwort } from "../../../shared/response/kernantwort.model";
import { SessionService } from "../../../shared/session.service";
import { Datei } from "../../datei/datei.model";
import { OaseDataSource } from "../oase.datasource";
import { RestServiceImpl } from "../rest.service.impl";
import { RestService } from "../rest.service.interface";

@Directive()
export class Tabelle<T> {
    OBJ_LNG_NAME: string = null;
    BACKEND_PATH_PREFIX = null;
    ROUTE_NAME = null;
    PATH_FILE = null;

    displayedColumns: string[] = null;

    dataSource: OaseDataSource<T> | null;
    dataService: RestService | null;
    ladedaten: boolean = true;
    extraDataForAdding: any = null;

    isImagePopupOpen: boolean = false;
    imagePopupPointer: number = 0;
    imagePopupImages: Image[] = new Array<Image>();

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('filter', { static: true }) filter: ElementRef;

    fehlerMain: Kernantwort = null;

    aktuellbilder: Array<Datei> = Array<Datei>();

    derivedColumns: any[] = [];
    apiParams: string = null;
    defaultSortColumn: string = null;
    defaultSortStart: SortDirection = 'asc';

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public breadcrumbService: BreadcrumbService,
        public snackBar: MatSnackBar,
        public authService: AuthService,
        public http: HttpClient,
        public translation: L10nTranslationService,
        public dialog: MatDialog,
        public media: MediaObserver,
        public changeDetectorRef: ChangeDetectorRef,
        public sessService: SessionService,
        public title: Title,
        public _logger: LoggerService,
        public apiConfigService: APIConfigService,
        public tabelleConfig: any) {

        this.OBJ_LNG_NAME = tabelleConfig.OBJ_LNG_NAME;
        this.BACKEND_PATH_PREFIX = tabelleConfig.BACKEND_PATH_PREFIX;
        this.PATH_FILE = tabelleConfig.PATH_FILE;
        this.displayedColumns = tabelleConfig.displayedColumns;
        this.apiParams = this.getApiParams();
        this.extraDataForAdding = tabelleConfig.extraDataForAdding;
        this.defaultSortColumn = tabelleConfig.UEBERSETZUNG_FELDNAME ?? tabelleConfig.DEFAULT_SORT_COLUMN;
        this.defaultSortStart = tabelleConfig.DEFAULT_SORT_START ?? 'asc';

        // Set document title.
        this.title.setTitle(this.getTitle());
        this.setBreadCrumbs();
        this.setDerivedColumns();
        this.sessService.logSessionInfos(this.PATH_FILE);
    }

    setBreadCrumbs() {
        // to override
    }

    public extraInit() {
        this.paginator._intl.itemsPerPageLabel = this.translation.translate('allgemein.items') + ':';
        this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            const start = page * pageSize + 1;
            const end = (page + 1) * pageSize;
            const final_end = end < length ? end : length;
            return `${start} - ${final_end} ${this.translation.translate('allgemein.of')} ${length}`;
        };


    }

    public afterDataIsLoaded() {
        // to override
    }

    onMobile() {
        return this.media.isActive('gt-sm') ? 'none' : '';
    }

    onDesktop() {
        return !this.media.isActive('gt-sm') ? 'none' : '';
    }

    reloadWithData() {
        let query = this.formQueryString();
        this.dataSource._extraChange.next(query);
    }

    formQueryString(): string {
        // to override
        return '';
    }

    public get REST_API(): string {
        return this.apiConfigService.REST_API_BASE() + this.BACKEND_PATH_PREFIX;
    }

    ngOnInit() {
        this._logger.log(this.PATH_FILE + ' - TABLE ngOnInit');

        this.extraInit();

        this.sort.active = this.defaultSortColumn; // Name der Spalte welche nach welcher beim ersten Aufruf Sortiert werden soll
        this.sort.start = this.defaultSortStart === 'desc' ? 'desc' : 'asc'; // Sortierrichtung nach welcher beim ersten Aufruf Sortiert werden soll
        this.sort.direction = this.defaultSortStart === 'desc' ? 'desc' : 'asc'; // Sortierrichtung nach welcher beim ersten Aufruf Sortiert werden soll
        this.sort.disableClear = true; // Deaktivieren der "ohne" Sortierung
        this.dataService = new RestServiceImpl(this.authService, this.http, this.translation, this.apiConfigService, this._logger);
        this.dataService.apiUrlPrefix = this.BACKEND_PATH_PREFIX; // Dies ist notwendig da ich keine Möglichkeit gefunden habe diesen Wert anders zu übergeben
        this.dataService.API_LIST = (this.apiParams != null && this.apiParams !== '') ? this.dataService.API_LIST + '/' + this.apiParams : this.dataService.API_LIST;

        this._logger.log(this.PATH_FILE + ' paginator ', this.paginator);

        this.dataSource = new OaseDataSource<T>(this.dataService, this.paginator, this.sort, this._logger, this.afterDataIsLoaded.bind(this));
        if (this.filter) {
            fromEvent(this.filter.nativeElement, 'keyup').pipe(
                debounceTime(300),
                distinctUntilChanged()
            ).subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        }
    }

    speichernSortAend(element: T) {
        this._logger.log(this.PATH_FILE + ' - speichernAend BEGIN');
        this._logger.log(this.PATH_FILE + ' - speichernAend - element: ', element);

        let snacknachricht = this.translation.translate('allgemein.daten.sortgeändert', {
            fall4: this.translation.translate(this.OBJ_LNG_NAME + '.artikel.fall4'), typ: this.translation.translate(this.OBJ_LNG_NAME + '.typ')
        });
        this.speichern(element, snacknachricht, true);
    }


    clearFilter() {
        if (this.dataSource.isWaitingForResponse || this.filter.nativeElement.value == '') return;
        this.dataSource.filter = '';
        this.filter.nativeElement.value = '';
        this.filter.nativeElement.blur();
    }

    setDerivedColumns() {
        // to override
    }

    getApiParams() {
        return ""; // to override
    }

    isDerivedColumn(name: string) {
        return this.derivedColumns.find((el) => {
            return el.key === name;
        }) != null;
    }

    getDerivedColumnValue(row: { typ: any }, name: string) {
        let derivedColumn = this.derivedColumns.find((el) => {
            return el.key === name;
        });

        if (derivedColumn == null)
            return "";

        if (derivedColumn.internalName == null)
            return row[derivedColumn.key];

        return row[derivedColumn.internalName] == null ?
            row[derivedColumn.internalName] = ((row) => {
                if (row.typ == null) row.typ = this.getType();
                return derivedColumn.f(row);
            })(row)
            : row[derivedColumn.internalName];

    }

    getType(): any {
        return null;// to override
    }

    ngAfterViewChecked() {
        this.changeDetectorRef.detectChanges();
    }

    getTitle() {
        return this.translation.translate(this.OBJ_LNG_NAME + '.title') + ' - ' + this.translation.translate('project.title');
    }

    openSnackBar(message: string, action: string = null) {
        this.snackBar.open(message, action, { duration: 5 * 1000 });
    }

    navigiereZuInhalten(element: T, route: string) {
        this.setSessionToElement(element);
        this.router.navigate([route]);
    } // navigiereZuInhalten

    setSessionToElement(element: T) {
        // to override
        // this.sessService.setThema(thema);
    }

    loeschenSpalteName() {
        // to override
        return null;
    }

    zeigeLoeschenMaske(element: T) {
        // for overriding
        //     this._zeigeLoeschenMaske(element, ThemaDeleteDialogComponent);
    }

    protected _zeigeLoeschenMaske(element: T, deleteDialog) {
        let dialogRefDelete = this.dialog.open(deleteDialog, {
            width: '600px',
            data: {
                aktuell: element,
                OBJ_LNG_NAME: this.OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
                UEBERSETZUNG_FELDNAME: this.loeschenSpalteName()
            }
        });

        dialogRefDelete.afterClosed().subscribe((elemDeleted: boolean) => {
            if (elemDeleted) {

                this.openSnackBar(this.translation.translate('allgemein.daten.gelöscht', { typ: this.translation.translate(this.OBJ_LNG_NAME + '.typ') }));
                this.dataSource._reloadData.next(true); // Der Datenquelle mitteilen das sich Daten geändert habe und die Aktuelle Seite neu zu laden ist.
            }
        });
    }

    // zeigeLoeschenMaske

    createNewElement() {
        return null;
        // to override
        // return new T();
    }

    zeigeHinzufuegenMaske() {
        // to override
        // this._zeigeHinzufuegenMaske(ThemaInsertEditComponent);
    }

    vorHinzufuegen(element) {
        // to override
    }

    protected _zeigeHinzufuegenMaske(insertEditDialog) {
        let element = this.createNewElement();

        console.log(element);

        this.vorHinzufuegen(element);

        this._logger.log(this.PATH_FILE + ' - zeigeHinzufuegenMaske element:', element);

        let newData = {
            aktuell: JSON.parse(JSON.stringify(element)),
            OBJ_LNG_NAME: this.OBJ_LNG_NAME,
            BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
            aktuellbilder: this.aktuellbilder,
            neu: true,
        };

        let self = this;

        if (self.extraDataForAdding != null) {
            Object.keys(self.extraDataForAdding).forEach(function (key) {
                newData[key] = self.extraDataForAdding[key];
            })
        }

        const dialogRefAdd = this.dialog.open(insertEditDialog, {
            width: '600px',
            data: newData
        });

        dialogRefAdd.afterClosed().subscribe((elemInserted: boolean) => {
            if (elemInserted) {
                this.openSnackBar(this.translation.translate('allgemein.daten.hinzugefügt', { typ: this.translation.translate(this.OBJ_LNG_NAME + '.typ') }));
                this.dataSource._reloadData.next(true); // Der Datenquelle mitteilen das sich Daten geändert habe und die Aktuelle Seite neu zu laden ist.
            }
        });
    }

    // zeigeHinzufuegenMaske


    zeigeBearbeitenMaske(element) {
        // to override
        // this._zeigeBearbeitenMaske(element, ThemaInsertEditComponent);
    }

    protected _zeigeBearbeitenMaske(element, insertEditDialog) {

        this._logger.log(this.PATH_FILE + ' - zeigeBearbeitenMaske element:', element);

        let newData = {
            aktuell: JSON.parse(JSON.stringify(element)),
            OBJ_LNG_NAME: this.OBJ_LNG_NAME,
            BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
            aktuellbilder: this.aktuellbilder,
            neu: false,
        };

        let self = this;

        if (self.extraDataForAdding != null) {
            Object.keys(self.extraDataForAdding).forEach(function (key) {
                newData[key] = self.extraDataForAdding[key];
            })
        }

        const dialogRefEdit = this.dialog.open(insertEditDialog, {
            width: '600px',
            data: newData
        });

        dialogRefEdit.afterClosed().subscribe((elemEdited: boolean) => {
            if (elemEdited) {
                this.openSnackBar(this.translation.translate('allgemein.daten.geändert', { typ: this.translation.translate(this.OBJ_LNG_NAME + '.typ') }));
                this.dataSource._reloadData.next(true); // Der Datenquelle mitteilen das sich Daten geändert habe und die Aktuelle Seite neu zu laden ist.
            }
        });
    }

    setzeFehler(fehler: Kernantwort) {
        this.fehlerMain = fehler;
    }

    protected speichern(element, snacknachricht, reload: boolean = false) {
        this.dataService.apiUrlPrefix = this.BACKEND_PATH_PREFIX;

        this._logger.debug(this.PATH_FILE + ' - speichern BEGIN');
        this._logger.debug(this.PATH_FILE + ' - speichern - element: ', JSON.stringify(element));
        this._logger.debug(this.PATH_FILE + ' - speichern - element: ', element);

        let themaTmp = JSON.parse(JSON.stringify(element));

        this._logger.debug(this.PATH_FILE + ' - speichern - tmp AFTER: ', JSON.stringify(themaTmp));
        this._logger.debug(this.PATH_FILE + ' - speichern - tmp AFTER: ', themaTmp);
        this._logger.debug(this.PATH_FILE + ' - speichern - this.aktuell AFTER: ', JSON.parse(JSON.stringify(element)));

        this.dataService.speichernAendern(element).subscribe(() => {
            if (reload) {
                this.dataSource._reloadData.next(true); // Der Datenquelle mitteilen das sich Daten geändert habe und die Aktuelle Seite neu zu laden ist.
            }
            this.openSnackBar(snacknachricht);
        });

    }
}

